import React from "react";
import { useEffect, useState } from "react";
import "./Home.css";
import { toast } from 'react-toastify';
import { BrowserRouter, Link, Router } from 'react-router-dom'

import "bootstrap/dist/css/bootstrap.min.css";
import Hero from "../../component/hero/Hero";


import GameCard from "../../component/GameCard/GameCard";
import PromotionCard from "../../component/PromotionCard/PromotionCard";

import FavoriteStore from "../../component/FavouriteStore/FavoriteStore";
import { useDispatch, useSelector } from "react-redux";
import { getFromLocalStorage, getUrlData } from "../../redux/actions/index";
import SkeltonEffect from "../../component/SkeltonEffect/SkeltonEffect";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import GameCard2 from "../../component/GameCard2/GameCard2";
import Footer from "../../component/Footer/Footer";
import SearchComp from "../../component/SearchComponent/SearchComp";
import FilterComp from "../../component/FilterComponent/FilterComp";

import PromotionEffect from "../../component/PromotionEffect/PromotionEffect";
import GameCardEffect from "../../component/GameCardEffect /GameCardEffect";
import promotionData from "../../dataset/promotion.json";
import gamesData from "../../dataset/llk88.json";
import filterJson from "../../dataset/gamefilter.json";
import { articlesData } from "../Articles/articlesData";
import { useTranslation } from 'react-i18next';
import ArticleCard from "../../component/ArticleCard/ArticleCard";
import LogoLoop from "../../component/LogoLoop/LogoLoop";
import Nav2 from "../../component/navBar2/Nav2";


function Home() {
  const { t } = useTranslation(); // ดึงฟังก์ชันแปลจาก useTranslation
  const handleScrollUp = () => {
    console.log('handle')
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
  }
  const notify = () => toast(" 🐱‍🏍 added   to favourite successfully ", {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark"
  })

  const responsive2 = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2
    }
  };
  const dispatch = useDispatch();
  const GamesData = useSelector((state) => state.allGame.Games); // array of Games => 15 array
  const sraechVal = useSelector((state) => state.allGame.searchValue);
  const filterVal = useSelector((state) => state.allGame.filterValue);
  let [pageNumber, setpageNumber] = useState(1);
  let [filter, setpageFilter] = useState(7);
  let [search, setsearch] = useState("");
  let [isloading, setisLoading] = useState(false);
  const filters = filterJson
  const articles = articlesData

  // useEffect(() => {
  //   setisLoading(true);

  //   setTimeout(() => {
  //     setisLoading(false);
  //   }, 2000);
  //   dispatch(getUrlData(pageNumber, search, filter));
  // }, [pageNumber]);

  // useEffect(() => {
  //   setisLoading(true);

  //   setTimeout(() => {
  //     setisLoading(false);
  //   }, 2000);
  //   dispatch(getUrlData(pageNumber, search, filter));
  // }, [pageNumber]);


  // useEffect(() => {
  //   setisLoading(true);

  //   setTimeout(() => {
  //     setisLoading(false);
  //   }, 2000);




  //   dispatch(getUrlData(pageNumber, search, filterVal));
  // }, [filterVal]);

  // useEffect(() => {
  //   setisLoading(true);
  //   setTimeout(() => {
  //     setisLoading(false);
  //   }, 2000);
  //   dispatch(getUrlData(pageNumber, sraechVal, filterVal));
  // }, [sraechVal]);

  const [favorite, setfavorite] = useState(JSON.parse(localStorage.getItem("FavouriteItems")) ? JSON.parse(localStorage.getItem("FavouriteItems")) : ['kjkm']);

  useEffect(() => {
    let getitemFromLocal = localStorage.getItem("FavouriteItems") ? JSON.parse(localStorage.getItem("FavouriteItems")) : [];

    console.log(getitemFromLocal);
    setfavorite(getitemFromLocal);

    dispatch(
      getFromLocalStorage(JSON.parse(localStorage.getItem("FavouriteItems")))
    );
  }, []);

  const [alert, setalert] = useState("");
  // let alert='kjwidjqiwojiojciowoejfdiowejfioejfioqej';
  let setToLocalStorage = (ele) => {
    localStorage.setItem("FavouriteItems", JSON.stringify(ele));
  };

  return (
    <div>
      <div className="col-8 d-none d-lg-block mt-2">



      </div>

      {filters.map((filter, index) => (
        filter.category === "all" ? <></> : <div key={index} > {/* ต้องมี key ที่ unique */}
          <p className="title text-light mb-0 mt-1" style={{ fontSize: "18px", fontWeight: "bold", textDecoration: "none" }}>

            {t(filter.category)}

          </p>

          <Carousel responsive={responsive2}>
            {isloading
              ? gamesData.map((ele) => <GameCardEffect key={ele.id} />)
              : gamesData
                .filter((ele) => ele.game_category.includes(filter.category)) // ใช้ filter ตาม category ของแต่ละ filter
                .map((ele) => <GameCard2 key={ele.id} element={ele} />)}
          </Carousel>
        </div>
      ))}

      {/* <p className="title text-light mb-0 mt-1" style={{ fontSize: "18px", fontWeight: "bold", textDecoration: "none" }}>

        {t("articles")}

      </p>

      <Carousel responsive={responsive2}>
        {isloading
          ? gamesData.map((ele) => <GameCardEffect key={ele.id} />)
          : articlesData
            .map((ele) => {
              return (
                <ArticleCard key={ele.id} element={ele} />

              );
            })}
      </Carousel> */}
      <section style={{ height: "60px" }}></section>

      <LogoLoop />
      <section style={{ height: "60px" }}></section>
      <div>
        <h1>{t('title')}</h1>
        <p>{t('welcome')}</p>

        <h2>{t('whyChooseRN69')}</h2>
        <ul>
          <li>{t('webDirect')}</li>
          <li>{t('varietyGames')}</li>
          <li>{t('promotions')}</li>
          <li>{t('service24h')}</li>
        </ul>

        <h2>{t('autoDeposit')}</h2>
        <p>{t('autoDeposit')}</p>

        <h2>{t('casinoComplete')}</h2>
        <p>{t('casinoComplete')}</p>

        <h2>{t('joinNow')}</h2>
        <p>{t('joinNow')}</p>

        <h2>{t('contactUs')}</h2>
        <p>{t('contactUs')}</p>

        <strong style={{ cursor: 'pointer' }} onClick={() => window.location.href = process.env.REACT_APP_LINE}>
          LINE:@RN69
        </strong>


      </div>





      {/* <p className="log text-light mb-0" style={{ fontSize: "18px", fontWeight: "bold", textDecoration: "none" }}>Top</p>

      <Carousel responsive={responsive2}>

        {isloading
          ? gamesData.map((ele) => {
            return <GameCardEffect key={ele.id} />;
          })
          : gamesData.filter((ele) => ele.game_category.includes('sport')) // กรองเฉพาะ keywords ที่เป็น "top"
            .map((ele) => {
              return (
                <GameCard2
                  key={ele.id}
                  element={ele}
                />
              );
            })}


      </Carousel> */}

    </div >
  );
}

export default Home;
